import useRestrictRuleModal from './useRestrictRuleModal';

export default useRestrictRuleModal;
